import React, { useEffect, useRef, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { COLOR_BY_LABELS, COLOR_LOOK_LABELS } from '../colorLook';

// One button, "Color by: Dance style", with the look inside. Andrew, 2026-10-12:
// people set this once, so it should not be a row of buttons; and it must not
// read as a colour style, so "Dance style" is spelled out and the button names
// the colour-by, never the look. "Colors" alone was rejected as unclear.

const S = {
    wrap: { position:'relative' },
    btn: { display:'flex', alignItems:'center', gap:6, fontSize:12, padding:'6px 10px', borderRadius:7,
        border:'1px solid #d9d9e8', background:'#fff', color:'#3f3f55', cursor:'pointer', fontFamily:'inherit' },
    lab: { color:'#7a7a99' },
    pop: { position:'absolute', top:'calc(100% + 6px)', left:0, zIndex:60, width:300, background:'#fff',
        border:'1px solid #e0e0ec', borderRadius:10, boxShadow:'0 8px 28px rgba(40,40,60,.16)', padding:'10px 12px 12px' },
    sec: { fontSize:10, fontWeight:700, color:'#a0a0bc', textTransform:'uppercase', letterSpacing:.5, margin:'4px 0 6px' },
    chips: { display:'flex', gap:4, flexWrap:'wrap', marginBottom:10 },
    chip: (on) => ({ fontSize:12, padding:'5px 10px', borderRadius:6, cursor:'pointer', fontFamily:'inherit',
        border: `1px solid ${on ? '#a8dff2' : '#d9d9e8'}`, background: on ? '#e6f7fd' : '#fff',
        color: on ? '#1a94ba' : '#5a5a7a', fontWeight: on ? 600 : 400 }),
    look: (on) => ({ display:'flex', alignItems:'center', gap:6, padding:'5px 8px', borderRadius:6, cursor:'pointer',
        border: `1px solid ${on ? '#29b8e5' : '#d9d9e8'}`, boxShadow: on ? '0 0 0 2px #e6f7fd' : 'none',
        background:'#fff', fontSize:11, color:'#5a5a7a', fontFamily:'inherit' }),
    ico: (look) => ({
        width:16, height:12, borderRadius:3, position:'relative', boxSizing:'border-box',
        border: look === 'outline' ? '1.5px solid #8b35c8' : '1px solid #c8c8e0',
        borderLeft: look === 'stripe' ? '3px solid #8b35c8' : undefined,
        background: look === 'fill' ? '#8b35c8' : '#fff',
    }),
    dot: { position:'absolute', left:2, top:2, width:6, height:6, borderRadius:'50%', background:'#8b35c8' },
    foot: { fontSize:10, color:'#9999bb', marginTop:10, lineHeight:1.4 },
};

export default function ColorMenu({ colorBy, colorLook, onChange }) {
    const [open, setOpen] = useState(false);
    const ref = useRef();
    useEffect(() => {
        const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', h);
        return () => document.removeEventListener('mousedown', h);
    }, []);

    return (
        <div ref={ref} style={S.wrap}>
            <button type="button" style={S.btn} onClick={() => setOpen((o) => !o)} aria-haspopup="true" aria-expanded={open}>
                <span style={S.lab}>Color by:</span> <b>{COLOR_BY_LABELS[colorBy] || 'None'}</b> <FiChevronDown size={12} color="#9999bb"/>
            </button>
            {open && (
                <div style={S.pop} role="dialog" aria-label="Card colours">
                    <div style={S.sec}>Color cards by</div>
                    <div style={S.chips}>
                        {Object.entries(COLOR_BY_LABELS).map(([k, label]) => (
                            <button key={k} type="button" style={S.chip(colorBy === k)} onClick={() => onChange({ colorBy: k })}>{label}</button>
                        ))}
                    </div>
                    <div style={S.sec}>Look</div>
                    <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                        {Object.entries(COLOR_LOOK_LABELS).map(([k, label]) => (
                            <button key={k} type="button" style={S.look(colorLook === k)} onClick={() => onChange({ colorLook: k })}>
                                <span style={S.ico(k)}>{k === 'dot' && <span style={S.dot}/>}</span>{label}
                            </button>
                        ))}
                    </div>
                    <div style={S.foot}>Saved with this recital. Same on the Assign Board and the running order.</div>
                </div>
            )}
        </div>
    );
}
